export function getComparableOffer(offer) {
    try {
        const { approvalDecisions, premium, tracking, insuredObjects, ...offerRest } = offer;
        return {
            ...offerRest,
            insuredObjects: insuredObjects?.map((insuredObject) => ({
                ...insuredObject,
                insuranceSegments: insuredObject?.insuranceSegments?.map((segment) => {
                    if (segment && 'premium' in segment) {
                        const { premium, ...rest } = segment;
                        return rest;
                    }
                    return segment;
                }),
            })),
        };
    }
    catch (e) {
        return {};
    }
}
